import { render, staticRenderFns } from "./lotteryList.vue?vue&type=template&id=31f5031f&scoped=true&"
import script from "./lotteryList.vue?vue&type=script&lang=js&"
export * from "./lotteryList.vue?vue&type=script&lang=js&"
import style0 from "./lotteryList.vue?vue&type=style&index=0&id=31f5031f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f5031f",
  null
  
)

export default component.exports